import { useEffect, useRef, useState } from "react";
import "./settings.scss";
import { useNotification } from "../../context/NotificationContext";
import LoaderBtn from "../LoaderBtn/LoaderBtn";
import { resetPassword, updateProfile, uploadImage } from "../../api/requests";
import { X, Edit2, User2Icon, EyeOff, EyeIcon } from "lucide-react";

import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../services/cropImage";
import { useUser } from "../../context/UserContext";
import { Autocomplete } from "@react-google-maps/api";
import 'animate.css'




const Settings = () => {
    const { notify } = useNotification();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const { currentUser, reloadUser } = useUser()



    const [inputData, setInputData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        address: "",
        image_url: "",
        isLoading: false,
    });


    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    

       useEffect(() => {

        const pacContainers = document.querySelectorAll('.pac-container') as NodeListOf<HTMLElement>;
        pacContainers.forEach((pac) => {
            pac.style.borderTop = 'none';
        });

    }, []);


    useEffect(() => {

        if (currentUser) {
            setInputData({
                firstname: currentUser.first_name,
                lastname: currentUser.last_name,
                email: currentUser.email,
                phone: currentUser.phone_number,
                address: currentUser.location ?? '',
                image_url: currentUser.image ? currentUser.image : '',
                isLoading: false
            })
        }

    }, [currentUser])

    const [resetPasswordData, setResetPasswordData] = useState({
        currentpassword: "",
        newpassword: "",
        confirm_newpassword: "",
        isLoading: false,
    });

    const [showPasswords, setShowPasswords] = useState({
        currentpassword: false,
        newpassword: false,
        confirm_newpassword: false,
    });

    const togglePasswordVisibility = (key: keyof typeof showPasswords) => {
        setShowPasswords((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    type imageUploadProp = {
        image: File | null,
        isImageAdded: boolean,
        imagePreview: string
    }

    const [imageUpload, setImageUpload] = useState<imageUploadProp>({
        image: null,
        isImageAdded: false,
        imagePreview: '',
    })


     const handlePlaceChanged = () => {
        const place = autocompleteRef.current?.getPlace();
        if (!place || !place.address_components) return;

        // const getComponent = (types: string[]) =>
        //     place.address_components?.find(c => types.some(t => c.types.includes(t)))?.long_name || "";

        const address = place.formatted_address || "";
        // const city = getComponent(["locality", "administrative_area_level_2"]);
        // const state = getComponent(["administrative_area_level_1"]);
        // const country = getComponent(["country"]);
        // const zip = getComponent(["postal_code"]);

        setInputData(prev => ({
            ...prev,
            address,
        }));

        // This line closes the dropdown
        inputRef.current?.blur();
    };

    const onCropComplete = (_: any, croppedAreaPixels: any) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const handleCropSave = async () => {
        if (imageUpload.image && croppedAreaPixels) {
            const croppedImage = await getCroppedImg(imageUpload.imagePreview, croppedAreaPixels);

            setImageUpload({
                image: croppedImage.file,
                isImageAdded: true,
                imagePreview: croppedImage.url,
            });

            setShowCropper(false);
        }
    };




    const handleFileClick = () => {
        fileInputRef.current?.click();
    };



    const isAllInputValid = (data: any, requiredFields: string[]) => {
        return requiredFields.every((field) => {
            const value = (data as any)[field];
            return typeof value === "string" && value.trim() !== "";
        });
    };

    function isValidPhoneNumber(phone: string) {
        return /^\+?[0-9\s-]{10,15}$/.test(phone);
    }

function isValidEmail(email: string): boolean {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.trim());
}



    const handleInput = (key: string, value: string | boolean) => {
    
        setInputData((prev) => {
            return {
                ...prev,
                [key]: value,
            };
        });
    };

    const handlePassInput = (key: string, value: string | boolean) => {
        setResetPasswordData((prev) => {
            return {
                ...prev,
                [key]: value,
            };
        });
    };


    const setResetLoader = (value: boolean) => {
        setResetPasswordData((prev) => {
            return {
                ...prev,
                isLoading: value,
            };
        });
    };

    const setInputLoader = (value: boolean) => {
        setInputData((prev) => {
            return {
                ...prev,
                isLoading: value,
            };
        });
    };

    const handleReset = async () => {
        try {
            setResetLoader(true);

            if (
                !isAllInputValid(resetPasswordData, [
                    "currentpassword",
                    "newpassword",
                    "confirm_newpassword",
                ])
            ) {
                throw Error("Please fill in all reset password fields");
            }

            if (
                resetPasswordData.newpassword !== resetPasswordData.confirm_newpassword
            ) {
                throw Error("New password and confirm password does not match!");
            }

            const body = {
                current_password: resetPasswordData.currentpassword,
                new_password: resetPasswordData.newpassword,
                confirm_password: resetPasswordData.confirm_newpassword,
            };

            let resp = await resetPassword(body);

            if (resp) {
                setResetPasswordData({
                    currentpassword: "",
                    newpassword: "",
                    confirm_newpassword: "",
                    isLoading: false,
                });

                notify.success("Password has been reset successfully!");
            }
        } catch (error: any) {
            notify.error(error.message);
        } finally {
            setResetLoader(false);
        }
    };



    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // console.log('File Change', e)
        const file = e.target.files?.[0];
        if (file) {
            const preview = URL.createObjectURL(file);
            setImageUpload({ image: file, isImageAdded: false, imagePreview: preview });
            setShowCropper(true);
        }
    };


    const handlePreviewDelete = () => {
        if (imageUpload.imagePreview) {
            URL.revokeObjectURL(imageUpload.imagePreview);
        }

        setImageUpload({
            image: null,
            isImageAdded: false,
            imagePreview: ''
        });


        if (fileInputRef.current) {
            fileInputRef.current.value = "";

            console.log(fileInputRef.current.value)
        }

    };


    const saveInput = async () => {
        try {
            setInputLoader(true);

            if (
                !isAllInputValid(inputData, [
                    "firstname",
                    "lastname",
                    "email",
                    "phone"
                ])
            ) {
                throw Error("Please fill in all profile fields");
            }

            if(!isValidEmail(inputData.email)) throw Error("Please enter a valid e-mail")

            if(!isValidPhoneNumber(inputData.phone)) throw Error("Please enter a valid phone number")


            let image_url

            if (imageUpload.isImageAdded) {

                const formData = new FormData();
                formData.append("file", imageUpload.image!);
                formData.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET!);

                image_url = await uploadImage(process.env.REACT_APP_CLOUDINARY_CLOUD_NAME!, formData)

            } else {
                image_url = inputData.image_url
            }


            const body = {
                email: inputData.email,
                image: image_url,
                first_name: inputData.firstname,
                last_name: inputData.lastname,
                telephone_no: inputData.phone,
                location: inputData.address,
            };

            let resp = await updateProfile(body)
            await reloadUser()

            if (resp) {
                handlePreviewDelete()
                notify.success("Details updated succesfully!");
            }
        } catch (error: any) {
            notify.error(error.message);
        } finally {
            setInputLoader(false);
        }
    }


    return (
        <div className="settings animate__animated animate__fadeIn animate__fast">
            <div className="centerbox">
                <div className="userflex">


                    <div className="userImg">
                        <input type="file" ref={fileInputRef} accept="image/*" onChange={handleFileChange} style={{ display: "none" }} />


                        {!imageUpload.isImageAdded && (<>
                            <div className="addImageIcon" onClick={handleFileClick}></div>


                            {inputData.image_url !== '' && (<img alt="df" src={inputData.image_url} className="defaultimg"></img>)}


                            {inputData.image_url === '' && (<User2Icon size={32} color='#fff' strokeWidth={1.6}></User2Icon>)}

                        </>)}



                        {imageUpload.isImageAdded && (
                            <div className="previewbox">
                                <img alt="preview" src={imageUpload.imagePreview} className="previewimg"></img>

                                <div className="edit" onClick={handleFileClick}>
                                    <Edit2 size={14}></Edit2>
                                </div>
                                <div className="delete" onClick={handlePreviewDelete}>
                                    <X size={14}></X>
                                </div>

                            </div>
                        )}



                    </div>

                    <div className="textside">
                        <div className="nametext">{currentUser?.first_name} {currentUser?.last_name}</div>
                        <div className="emailtext">{currentUser?.email}</div>
                    </div>

                    {showCropper && (
                        <div className="cropper-modal">
                            <div className="cropper-content">
                                <div className="cropper-header">

                                    <span className="close-icon" onClick={() => setShowCropper(false)}>
                                        <X size={14}></X>
                                    </span>
                                </div>

                                <div className="cropper-body">
                                    <Cropper
                                        image={imageUpload.imagePreview}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={1}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>

                                <div className="cropper-footer">
                                    <button className="btn full" style={{ width: 'auto' }} onClick={handleCropSave}>Crop & Save</button>
                                </div>
                            </div>
                        </div>
                    )}



                </div>

                <div className="twoGrid">
                    <div className="inputArea">
                        <div className="title">Personal information</div>

                        <div className="inputPack">
                            <label className="inputTitle">First Name</label>
                            <input
                                className="inputBox"
                                type="text"
                                value={inputData.firstname}
                                onChange={(ev) =>
                                    handleInput("firstname", ev.currentTarget.value)
                                }
                            ></input>
                        </div>

                        <div className="inputPack">
                            <label className="inputTitle">Last Name</label>
                            <input
                                className="inputBox"
                                type="text"
                                value={inputData.lastname}
                                onChange={(ev) =>
                                    handleInput("lastname", ev.currentTarget.value)
                                }
                            ></input>
                        </div>

                        <div className="inputPack">
                            <label className="inputTitle">E-mail</label>
                            <input
                                className="inputBox"
                                type="email"
                                value={inputData.email}
                                disabled
                                onChange={(ev) => handleInput("email", ev.currentTarget.value)}
                            ></input>
                        </div>

                        <div className="inputPack">
                            <label className="inputTitle">Phone number</label>
                            <input
                                className="inputBox"
                                type="text"
                                value={inputData.phone}
                                onChange={(ev) => handleInput("phone", ev.currentTarget.value)}
                            ></input>
                        </div>

                        <div className="button-group">
                            <LoaderBtn className={"btn full"} clickFunction={saveInput} text={"Save changes"} isLoading={inputData.isLoading}></LoaderBtn>
                            {/* <div className="" onClick={}>
                Save changes
              </div> */}
                            {/* <div className='btn open'>Cancel</div> */}
                        </div>
                    </div>

                    <div className="inputArea">
                        <div className="title">Reset password</div>

                        <div className="inputPack passwordPack">
                            <label className="inputTitle">Current passord</label>
                            <input
                                className="inputBox"
                                type={showPasswords.currentpassword ? "text" : "password"}
                                value={resetPasswordData.currentpassword}
                                onChange={(ev) =>
                                    handlePassInput("currentpassword", ev.currentTarget.value)
                                }
                            ></input>
                            <div className="eyepack" onClick={() => togglePasswordVisibility("currentpassword")}>
                                {showPasswords.currentpassword ? <EyeOff size={20} /> : <EyeIcon size={20} />}
                            </div>
                        </div>

                        <div className="inputPack passwordPack">
                            <label className="inputTitle">New password</label>
                            <input
                                className="inputBox"
                                type={showPasswords.newpassword ? "text" : "password"}
                                value={resetPasswordData.newpassword}
                                onChange={(ev) =>
                                    handlePassInput("newpassword", ev.currentTarget.value)
                                }
                            ></input>
                            <div className="eyepack" onClick={() => togglePasswordVisibility("newpassword")}>
                                {showPasswords.newpassword ? <EyeOff size={20} /> : <EyeIcon size={20} />}
                            </div>
                        </div>

                        <div className="inputPack passwordPack">
                            <label className="inputTitle">Confirm password</label>
                            <input
                                className="inputBox"
                                type={showPasswords.confirm_newpassword ? "text" : "password"}
                                value={resetPasswordData.confirm_newpassword}
                                onChange={(ev) =>
                                    handlePassInput("confirm_newpassword", ev.currentTarget.value)
                                }
                            ></input>
                            <div className="eyepack" onClick={() => togglePasswordVisibility("confirm_newpassword")}>
                                {showPasswords.confirm_newpassword ? <EyeOff size={20} /> : <EyeIcon size={20} />}
                            </div>
                        </div>

                        <div className="button-group">
                            <LoaderBtn
                                className={"btn full"}
                                thickness={3}
                                clickFunction={handleReset}
                                text={"Reset password"}
                                isLoading={resetPasswordData.isLoading}
                            ></LoaderBtn>

                            {/* <div className='btn open'>Cancel</div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
